export const IS_LOCAL = process.env.ENV === 'LOCAL';

if (IS_LOCAL) {
  process.env.DEBUG = [
    '*:error',
    'init',
    'reservation',
    'reservation:*',
    'notifications',
    'editProfile',
    'exchange',
    'graphql',
    'user:*',
    'sql',
    'sql:*',
    '*:sql',
  ].join(',');
  process.env.DEBUG_COLORS = true;
}

import { getp } from './helpers/getProp';
/* eslint-disable max-len */
export const DEBUG = process.env.DEBUG || '*';
export const LOG_LEVEL = process.env.LOG_LEVEL || 'trace';
export const LOG_GROUPS = process.env.LOG_GROUPS || '';

export const port = process.env.PORT || 3000;
// export const host = process.env.WEBSITE_HOSTNAME || 'alpha.yoodlize.com';
// export const url = process.env.URL || 'https://alpha.yoodlize.com';
export const host = process.env.WEBSITE_HOSTNAME || 'localhost:3001';
export const url = process.env.URL || 'http://localhost:3001';
export const gql_url = (process.env.GQL_URL || 'http://localhost:3001') + '/graphql';
export const hasuraGqlUrl = process.env.HASRUA_GQL_URL || 'https://hasura-test-yoo.herokuapp.com/v1/graphql';

export const sitename = process.env.SITENAME || 'Yoodlize';

// default locale is the first one
export const locales = ['en-US'];

export const isWWW = process.env.ENV === 'PROD';
export const isDev = url.indexOf('//localhost') >= 0;
export const isNotificationEnabled = process.env.IS_NOTIFICATION_ENABLED || true;

const alphaDBURL =
  'postgres://vazdlmbnpupoqo:06356a5bb92e12b036969eb5cf3578360ff2d06dd655051fc7b5b1e46c9afaa9@ec2-52-6-75-198.compute-1.amazonaws.com:5432/d1uc1b9kc9fula';

export const databaseUrl = process.env.DATABASE_URL || alphaDBURL;
// 'postgres://Robertson@localhost:5432/yoo_local';
//Alpha

if (databaseUrl !== alphaDBURL) {
  console.log('!!!!!!! USING PROD DB   !!!!!!!');
}

// 'mysql://master:R3ntStuff@yoodle-dev.cj6sme48iklk.us-east-1.rds.amazonaws.com/dev';
// process.env.DATABASE_URL ||
// old prod
// 'mysql://jeremy_yoodlize:DpXe1e0s62xN@yoodlize-prod.cj6sme48iklk.us-east-1.rds.amazonaws.com/yoohoo';
// export const databaseUrl =
//   process.env.DATABASE_URL || 'mysql://root:Jellyb3ans@localhost/yoo2';

export const photoUploadUrl = process.env.IMAGE_UPLOAD_URL || '/photos';
export const avatarUploadUrl = process.env.AVATAR_UPLOAD_URL || '/uploadProfilePhoto';
//export const photoUploadUrl = process.env.IMAGE_UPLOAD_URL || '/photos';

export const s3Endpoint = process.env.S3_ENDPOINT || 'sfo2.digitaloceanspaces.com';
export const bucketName = process.env.S3_BUCKET || 'yimgs';

export const avatarBaseUrl = process.env.AVATAR_BASE_URL || `.sfo2.cdn.digitaloceanspaces.com/avatar`;

export const imageBaseUrl = process.env.IMAGE_BASE_URL || `.sfo2.cdn.digitaloceanspaces.com`;

// Listing Photos Upload Directory
export const fileuploadDir = process.env.FILEUPLOAD_DIR || './images/upload/';

// Logo upload directory
export const logouploadDir = process.env.LOGOUPLOAD_DIR || './images/logo/';

// Category upload directory
export const categoryUploadDir = process.env.LOGOUPLOAD_DIR || './images/category/';

// Home page Banner upload directory
export const banneruploadDir = process.env.BANNER_UPLOAD_DIR || './images/banner/';

// User Profile Photos Upload Directory
export const profilePhotouploadDir = process.env.PROFILE_PHOTO_UPLOAD_DIR || './images/avatar/';

// Document Upload
export const documentuploadDir = process.env.FILEUPLOAD_DIR || './images/document/';

export const analytics = {
  // https://analytics.google.com/
  google: {
    trackingId: process.env.GOOGLE_TRACKING_ID || 'UA-118640314 - 1',
  },
};

export const slack_token = process.env.SLACK_TOKEN || 'xoxb-363336353636-581747213248-Gm5yZ2128IcUN0LiHRL2r905';

export const supportEmail = {};

export const amplitudeApiKey = process.env.AMPLITUDE_KEY || '3b29c8d934d51f442a5a29190b91dda6';

export const facebookPixelID = process.env.PIXEL_ID || '';
export const quoraPixelID = process.env.QUORA_ID || '';

export const hasuraAdminKey = process.env.HASURA_ADMIN_KEY || 'setthebetanddontgetwet';

export const rollbarApiKey = '88416a25475b48748c0ced1931fe8064';

export const isBrowser = process.env.BROWSER;

export const isProduction2 = process.env.BROWSER
  ? getp(window, 'location.origin', '').indexOf('www.yoodlize') >= 0
  : process.env.ENV && process.env.ENV === 'PROD';

export const isProduction = process.env.BROWSER && getp(window, 'location.origin', '').indexOf('www.yoodlize') >= 0;

export const isProductionServer = process.env.ENV && process.env.ENV === 'PROD';

//Also need to change the key in Details.js
//PRODUCTION // export const googleMapAPI = 'AIzaSyBZJvWSZH1kNizVweV22OoBSFjImnytw-U';
//Dev
export const googleMapAPI = process.env.GOOGLE_MAP_API || 'AIzaSyBaJyhrC3tdLkFqzbC1Nxgh8Oul9I8a5b8';

//export const googleMapAPI = process.env.GOOGLE_MAP_API || 'AIzaSyDqz0MgE60D4jBsSHJz2S8wjvacVpc_ZNQ';
// site key for google recaptcha
export const googleCaptcha = {
  sitekey: process.env.GOOGLE_CAPTCHA || '6LcKa1MUAAAAAGT1914w0-yhcVoBfKWoXO64WhKp',
};

// SMS verification
export const sms = {
  twilio: {
    accountSid: process.env.TWILIO_SID || 'AC9d70336f1c67906f1234da9a90d44180',
    authToken: process.env.TWILIO_TOKEN || '144f71b167f834d246cf11a6962e9f6f',
    phoneNumber: process.env.TWILIO_PHONE || '+13852179005',
  },
};

export const mobileLoginToken = '91c52966288e4898be19b5bbe813b421';

export const payment = {
  paypal: {
    email: process.env.PAYPAL_APP_EMAIL || 'Admin-facilitator@yoodlize.com',
    clientId:
      process.env.PAYPAL_APP_CLIENT_ID ||
      'AfqyoQxIDle5a9j0pC97O6AEny38wIcwQnywmwK6oEerojbcDTJepnSYb5noJVshJzQ0uP2PBMitI9g_',
    secret:
      process.env.PAYPAL_APP_SECRET ||
      'EPMpQauqCr5NllL5tlhtYe3plFf3_VdfkYgmTG0IIigP5BRA46vOXwinrDiORc7a18WLuT5dnevzwcxh',
    mode: process.env.PAYPAL_MODE || 'sandbox',
    returnURL: process.env.PAYPAL_RETURN_URL || `${url}/success`,
    cancelURL: process.env.PAYPAL_CANCEL_URL || `${url}/cancel`,
    redirectURL: {
      success: process.env.PAYPAL_SUCCESS_URL || '/users/trips/itinerary',
      cancel: process.env.PAYPAL_CANCEL_URL || '/contact',
    },
  },

  stripe: {
    secretKey: process.env.STRIPE_SECRET || 'sk_test_4nhZnIg5lIleeynT4eHKzwoH',
  },
};

// Email Settings
export const emailConfig = {
  host: process.env.SMTP_HOST || 'smtp-pulse.com',
  port: process.env.SMTP_PORT || 2525,
  email: process.env.SMTP_LOGIN_EMAIL || 'admin@yoodlize.com',
  sender: process.env.SMTP_FROM_NAME || 'Yoodlize',
  password: process.env.SMTP_LOGIN_PASSWORD || 'a7B4LgGog7',
  secure: process.env.SMTP_SECURE || false,
  tls: process.env.SMTP_TLS || false,
};

export const auth = {
  jwt: {
    secret: process.env.JWT_SECRET || 'Lyri kly',

    //Keys must be escaped : awk -v ORS='\\n' '1' src/jwt-rsa.public
    privateKey:
      process.env.JWT_PRIVATE_KEY ||
      '-----BEGIN RSA PRIVATE KEY-----\nMIIBOgIBAAJBAPNtfUwXmhBZUGiaYuK/zAyhhS+ANcSwoVLXSd7YocTqmBnOiS1H\nI6HjTBxk2OnUmH388VWHWwGEejEXFYIL4VECAwEAAQJAN767EtHU1imd4FZ6jrKd\nZ8cVWOtjZMeOKgpjQEUbxpwAIiqWhKLsC3Ex6VCSxxiGDyZplFibbLJ2he298EPA\nAQIhAPvICZApfV3YqHTahSNYFvIW5paqjCaCeSQx6lJy666hAiEA94Ge43eeXdS9\nV5+3YjKSTdho5n4vVj99XK05y9OZpLECIBaFUAWrEGGijX7WRO5iZLsGvV1gp+SR\n6xAHvvPc/6PBAiEA9yisp1AbiG3aSndHJLuFmFEkqA+Ya9No97RQg/ehdXECIGtQ\n+hIZAwvj6ch+Ki6iXpKAhB24wqq9EjNVI1ZeBeE5\n-----END RSA PRIVATE KEY-----\n',
    publicKey:
      process.env.JWT_PUBLIC_KEY ||
      '-----BEGIN PUBLIC KEY-----\nMFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAPNtfUwXmhBZUGiaYuK/zAyhhS+ANcSw\noVLXSd7YocTqmBnOiS1HI6HjTBxk2OnUmH388VWHWwGEejEXFYIL4VECAwEAAQ==\n-----END PUBLIC KEY-----\n',
  },

  redirectURL: {
    login: process.env.REDIRECT_LOGIN || '/',
    verification: process.env.LOGIN_URL || '/user/verification',
  },

  // https://developers.facebook.com/
  facebook: {
    // id: process.env.FACEBOOK_APP_ID || '963270370729039', //test
    id: process.env.FACEBOOK_APP_ID || '2174664446082930',
    // secret: process.env.FACEBOOK_APP_SECRET || '519a9322913ecfcf39e4e8453e297400', //test
   secret: process.env.FACEBOOK_APP_SECRET || 'b99f81db0930e5fdabf347c40234ca58',
    returnURL: process.env.FACEBOOK_CLIENT_URL || 'http://localhost:3001/login/facebook/return',
  },

  // https://cloud.google.com/console/project
  google: {
    id: process.env.GOOGLE_CLIENT_ID || '334601646912-pg3r588nl9j4m64mbb9a551c58cn47b9.apps.googleusercontent.com',
    secret: process.env.GOOGLE_CLIENT_SECRET || 'DWNSwJ44B3GxwMeaKDJ-JqxT',
    returnURL: process.env.GOOGLE_CLIENT_URL || 'http://localhost:3001/login/google/return',
  },

  // https://apps.twitter.com/
  twitter: {
    key: process.env.TWITTER_CONSUMER_KEY || 'Ie20AZvLJI2lQD5Dsgxgjauns',
    secret: process.env.TWITTER_CONSUMER_SECRET || 'KTZ6cxoKnEakQCeSpZlaUCJWGAlTEBJj0y2EMkUBujA7zWSvaQ',
  },
};



// WEBPACK FOOTER //
// ./src/config.js